// An interactive guide, as opposed to the passive tours in *.tour.js.
//
// Passive tours explain what is on one page. A guide walks the user through a
// task that spans several pages: each stage names the page it belongs to, and
// the guide pauses at a page boundary until the user gets there, then resumes.
const createScheduleGuide = {
  id: 'create-schedule',
  kind: 'interactive',
  title: 'Create and fill a schedule',
  summary: 'From an empty project to a schedule with products in it.',
  version: 1,
  stages: [
    {
      id: 'project',
      // Any project edit page.
      match: '/dashboard/yawn/project/',
      waitingHint: 'Open a project to begin.',
      waitingAnchors: [
        { target: 'projects-add', hint: 'Open a project from this list to begin.' },
        { target: 'dashboard-new-project', hint: 'Open a project to begin.' },
        { target: 'nav-Projects', hint: 'Open Projects from the menu, then pick a project.' },
      ],
      steps: [
        {
          target: 'project-schedules-section',
          title: 'Start here',
          body: 'Every schedule for this project lives in this section. We will add one now.',
          placement: 'top',
          optional: true,
        },
        {
          target: 'project-add-schedule',
          title: 'Add a new schedule',
          body: 'Click "Add New" to open the schedule setup window.',
          placement: 'left',
        },
      ],
    },
    {
      id: 'dialog',
      match: '/dashboard/yawn/project/',
      // The dialog is not a page of its own, so this stage only runs once its
      // fields are actually on screen.
      requires: 'schedule-new-name',
      waitingHint: 'Open the schedule setup window to carry on.',
      waitingAnchors: [
        { target: 'project-add-schedule', hint: 'Click "Add New" to open the setup window.' },
        { target: 'nav-Projects', hint: 'Open Projects from the menu, then open your project.' },
      ],
      steps: [
        {
          target: 'schedule-new-name',
          title: 'Name your schedule',
          body: 'Give it a name you will recognise later, such as "External Fabric" or "Stage 3 Issue".',
          placement: 'bottom',
        },
        {
          target: 'schedule-new-create',
          title: 'Create it',
          body: 'Choose a Master template or a previous project to copy from, then click Create.',
          tip: 'Switch the Masters filter to No to start from one of your own projects instead.',
          placement: 'top',
        },
      ],
    },
    {
      id: 'sheet',
      match:
        '/dashboard/yawn/schedule/,!/dashboard/yawn/schedule/list,!/dashboard/yawn/schedule/new',
      waitingHint: 'Open your new schedule to carry on.',
      waitingAnchors: [
        { target: 'project-schedules-section', hint: 'Open your new schedule from this list.' },
        { target: 'nav-Schedules', hint: 'Open Schedules from the menu, then open yours.' },
      ],
      steps: [
        {
          target: 'sheet-nav-pane',
          title: 'You are in the schedule',
          body: 'Use the navigation pane to move between sections as you build it up.',
          placement: 'right',
          optional: true,
        },
        {
          target: 'sheet-row-menu',
          title: 'Add your items',
          body: 'Use a row menu to add rows, or open Library to bring items across from a previous project.',
          placement: 'right',
          optional: true,
        },
        {
          target: 'sheet-menu-bar',
          title: 'That is the groundwork done',
          body: 'From here you can pick products, add comments, set revisions and export — each has its own tour in the Help menu.',
          placement: 'bottom',
        },
      ],
    },
  ],
};

export default createScheduleGuide;
